import { useSyncExternalStore } from "react";

// A single app-wide toast (a newer one replaces the old), optionally with one
// action such as "Undo". Lives outside any page so it survives the list that
// raised it unmounting — e.g. moving the last entry off a status page.
export type Toast = {
  id: number;
  message: string;
  action?: { label: string; run: () => void };
};

let current: Toast | null = null;
let nextId = 0;
const listeners = new Set<() => void>();

const emit = () => listeners.forEach((listener) => listener());

export const showToast = (message: string, action?: Toast["action"]) => {
  current = { id: ++nextId, message, action };
  emit();
};

// Dismiss the toast, or only toast `id` if given (so a stale timer can't
// close a newer one).
export const dismissToast = (id?: number) => {
  if (id !== undefined && current?.id !== id) return;
  current = null;
  emit();
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useToast = (): Toast | null =>
  useSyncExternalStore(subscribe, () => current);
